export const decodeMacAddress= (macAddress)=>{
    const removeL = macAddress.slice(1)
    const upperCaseMAC = removeL.toUpperCase()
    const replaceSemiColon = upperCaseMAC.replaceAll(':', '')
    return replaceSemiColon
  }

export const decodeSerialNumber = (serialNumber) => {
    console.log("serialNumber", serialNumber)
    if (!serialNumber) return "";
    let toReturn = "";
    const serialArray = serialNumber.split("-");
    serialArray.forEach((num, i) => {
      const decimalValue = parseInt(num, 16); // Base 16 or hexadecimal
  
      const character = String.fromCharCode(decimalValue);
  
      toReturn += character;
    });
    return toReturn;
  };